/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { useToggle } from "react-use";
import { Button, Loader, ModalConfirm } from "@nordcloud/gnui";
import { generateActionConfirmText, inflect } from "~/tools";
import { useEstateRecordsExport } from "./components/hooks";

type ExportFilters = Parameters<
  ReturnType<typeof useEstateRecordsExport>[0]
>[0];

type Props = {
  recordsCount: number;
  filters: ExportFilters;
};

export function ExportV2({ recordsCount, filters }: Props) {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);
  const [exportEstates, { loading }] =
    useEstateRecordsExport(toggleIsModalOpen);

  return (
    <>
      <Button
        icon="download"
        severity="medium"
        disabled={recordsCount === 0}
        css={{ textTransform: "none" }}
        onClick={toggleIsModalOpen}
      >
        Export to CSV
      </Button>
      <ModalConfirm
        isOpen={isModalOpen}
        confirm={() => exportEstates(filters)}
        actionLabel="Export"
        contentLabel="Export Estate Records"
        onClose={toggleIsModalOpen}
      >
        <When condition={loading}>
          <Loader inContent />
        </When>
        Export generation process is going to take some time and the result file
        will be delivered to your email. <br />
        {generateActionConfirmText(
          `${recordsCount} ${inflect("record")(recordsCount)}`
        )("export")()}
      </ModalConfirm>
    </>
  );
}
